import { useRef, useEffect } from 'react'
import { CANVAS_WIDTH, CANVAS_HEIGHT } from '../utils/settings'

const AbstractCanvas = ({
  className = '',
  zIndex = 1,
  name = null,
  paintData = {},
  shouldRepaint = () => true,
  paint = () => {}
}) => {
  const canvasRef = useRef(null)
  const lastPaintDataRef = useRef(null)

  useEffect(() => {
    maybePaint()
  })

  const maybePaint = () => {
    if (
      !lastPaintDataRef.current ||
      shouldRepaint(lastPaintDataRef.current, paintData)
    ) {
      lastPaintDataRef.current = paintData
      const canvas = canvasRef.current
      const ctx = canvas.getContext('2d')
      paint(ctx, paintData)
    }
  }

  return (
    <canvas
      ref={canvasRef}
      data-name={name}
      className={className}
      style={{ zIndex }}
      width={CANVAS_WIDTH}
      height={CANVAS_HEIGHT}
    />
  )
}

export default AbstractCanvas
